import { Check, Minus, X, type LucideIcon } from 'lucide-react';

export type CheckedVerdict = 'correct' | 'incorrect' | 'partial';

/**
 * A checked answer's verdict, in words beside its icon. It used to read "Your
 * submitted answer" whatever the verdict, so only its colour said whether the
 * answer was right: nothing at all to a screen reader, or to anyone who cannot
 * tell the red from the green (issue #92).
 */
export const VERDICT_TAGS: Record<
  CheckedVerdict,
  { icon: LucideIcon; text: string; tone: 'error' | 'partial' | 'success' }
> = {
  correct: { icon: Check, text: 'Your answer: correct', tone: 'success' },
  incorrect: { icon: X, text: 'Your answer: incorrect', tone: 'error' },
  partial: { icon: Minus, text: 'Your answer: partly correct', tone: 'partial' },
};

interface CheckedAnswerTagProps {
  className?: string;
  iconClassName?: string;
  id?: string;
  verdict: CheckedVerdict;
}

export function CheckedAnswerTag({
  className,
  iconClassName,
  id,
  verdict,
}: CheckedAnswerTagProps) {
  const { icon: Icon, text, tone } = VERDICT_TAGS[verdict];

  return (
    <span className={className} data-tone={tone} id={id}>
      <Icon aria-hidden="true" className={iconClassName} size={14} />
      {text}
    </span>
  );
}
